// extracted by mini-css-extract-plugin
module.exports = {"amount_list":"ListOperationsEdit_amount_list__3HM76"};